var cultureRedirect = (function () {
	var publicMethods = {};

	publicMethods.init = function () {
		var selectedCulture = getCookie("selected-culture");
		var firstSlug = location.pathname.split("/")[1].toLowerCase();

		// Avoiding redirects for existing culture paths is more of a failsafe; we're not anticipating actual users to end up in this situation.
        if (new RegExp("^[a-z]{2}-[a-z]{2}$").test(firstSlug) == false) {
            if (selectedCulture && selectedCulture.toLowerCase() != firstSlug) {
				var newLocation = selectedCulture + window.location.pathname;
				window.location.replace("/" + newLocation);
			}
		}
	};

	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);

		if (parts.length === 2) {
			return parts.pop().split(";").shift();
		}

		return "";
	}

	return publicMethods;
})();

cultureRedirect.init();
